import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@skupreme/shared/ui';
import { ShadowBox } from '@elements/Common';

type DivProps = HTMLAttributes<HTMLDivElement>;

export const BoxHeader = forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...rest }, ref) => (
    <div
      {...rest}
      ref={ref}
      className={cn(
        'sk:flex sk:items-center sk:justify-between sk:border-0 sk:border-b sk:border-solid sk:border-border-subtle sk:p-4',
        className,
      )}
    />
  ),
);
BoxHeader.displayName = 'BoxHeader';

export const Box = forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...rest }, ref) => (
    <ShadowBox {...rest} ref={ref} className={cn('sk:p-0', className)} />
  ),
);
Box.displayName = 'Box';

export const BoxContainer = forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...rest }, ref) => (
    <div {...rest} ref={ref} className={cn('sk:p-4', className)} />
  ),
);
BoxContainer.displayName = 'BoxContainer';

export const Row = forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...rest }, ref) => (
    <div {...rest} ref={ref} className={cn('sk:mb-4', className)} />
  ),
);
Row.displayName = 'Row';

type ProgressBarProps = {
  progress: number;
  className?: string;
  /** A caller's own fill; otherwise success when complete, danger before. */
  customColor?: string;
};

export function ProgressBar({
  progress,
  className,
  customColor,
}: ProgressBarProps) {
  return (
    <div
      className={cn(
        'sk:relative sk:mx-auto sk:my-3 sk:h-2 sk:w-full sk:overflow-hidden sk:rounded-full sk:bg-fill-secondary',
        className,
      )}
    >
      <div
        className={cn(
          'sk:absolute sk:inset-y-0 sk:left-0 sk:rounded-full',
          !customColor && (progress === 100 ? 'sk:bg-success' : 'sk:bg-danger'),
        )}
        style={{
          width: `${progress}%`,
          backgroundColor: customColor,
        }}
      />
    </div>
  );
}
